import React, { useEffect, useMemo } from 'react';
import { Tag } from "antd";

import { RightSidebar } from "../../../_partials/Layout";
import { UserInterface } from "../../../../store/mine_craft/usersSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchBannedIps } from "../../../../actions/mine_craft/bannedIpsActions";
import RowInfo from "../../../../componets/RowInfo";
import { boolToText } from "../../../../helpers/TextHelpers";
import { formattedDate } from "../../../../helpers/DateHelpers";

const _SidebarShow = ({ user }: { user: UserInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const bannedIpEntities = useAppSelector(state => state.mineCraft.bannedIps.entities);
  const bannedIpIds = useAppSelector(state => state.mineCraft.bannedIps.ids);

  useEffect(() => {
    if (user) {
      dispatch(fetchBannedIps({ active: 'true' }));
    }
  }, [user, dispatch]);

  const bannedIpSet = useMemo(() => {
    const set = new Set<string>();
    if (bannedIpIds) {
      bannedIpIds.forEach(id => {
        const entry = bannedIpEntities[id];
        if (entry?.ip) set.add(entry.ip);
      });
    }
    return set;
  }, [bannedIpIds, bannedIpEntities]);

  const renderIp = (ip: string | null) => {
    if (!ip) return '—';
    if (bannedIpSet.has(ip)) {
      return <>{ip} <Tag color="error">Banned</Tag></>;
    }
    return ip;
  };

  const renderDetails = () => {
    if(!user) {
      return null;
    }

    const banned  = user.banned_until ? formattedDate(user.banned_until).dateTime : '';
    const muted   = user.muted_until ? formattedDate(user.muted_until).dateTime : '';

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={user.id} />
          <RowInfo left='Online' right={boolToText(user.is_online)} />
          <RowInfo left='Coins' right={user.coins} />
          <RowInfo left='Email' right={user.email} />
          <RowInfo left='Gamertag' right={user.gamertag || '—'} />
          <RowInfo left='Bundle Name' right={user?.bundle?.name} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Security</h6>

          <RowInfo left='Last Ban' right={banned} />
          <RowInfo left='Last Mute' right={muted} />
          <RowInfo left='Registration IP' right={renderIp(user.reg_sign_in_ip)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Active ADs</h6>

          <RowInfo left='Banner' right={boolToText(user.banner)} />
          <RowInfo left='Native Ads' right={boolToText(user.native_ads)} />
          <RowInfo left='App Open' right={boolToText(user.app_open)} />
          <RowInfo left='Interstitial' right={boolToText(user.interstitial)} />
          <RowInfo left='Interstitial Long' right={boolToText(user.interstitial_long)} />
        </div>

        <div>
          <h6 className='v-content-label o-sm'>Notifications</h6>

          <RowInfo left='Youtube video' right={boolToText(user.notify_youtube_video)} />
          <RowInfo left='App update' right={boolToText(user.notify_app_update)} />
          <RowInfo left='Follow posts' right={boolToText(user.notify_follow_posts)} />
          <RowInfo left='Follow' right={boolToText(user.notify_follow)} />
          <RowInfo left='Comment account' right={boolToText(user.notify_comment_account)} />
          <RowInfo left='Like account' right={boolToText(user.notify_like_account)} />
          <RowInfo left='Like post' right={boolToText(user.notify_like_post)} />
          <RowInfo left='Comment post' right={boolToText(user.notify_comment_post)} />
          <RowInfo left='Download post' right={boolToText(user.notify_download_post)} />
          <RowInfo left='Like comment' right={boolToText(user.notify_like_comment)} />
          <RowInfo left='Comment reply' right={boolToText(user.notify_comment_reply)} />
          <RowInfo left='Daily rewards' right={boolToText(user.notify_comment_reply)} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
